import { UPLOAD_SURGE_FILE, UPLOAD_SURGE_FILE_SUCCESS, UPLOAD_SURGE_FILE_ERROR, UPLOAD_SURGE_FILE_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UploadSurgeFile = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_SURGE_FILE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPLOAD_SURGE_FILE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPLOAD_SURGE_FILE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPLOAD_SURGE_FILE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UploadSurgeFile;
